import {
  knowledgeQuestionsResponseSchema,
  paths,
  type KnowledgeQuestionsResponse,
} from "@go-novus/admin-api";

import {
  requestBackendResult,
  type BackendFailure,
} from "#/shared/lib/backend-api";
import type { ResultAsync } from "#/shared/lib/result";

export const getKnowledgeQuestionsOperation = "knowledge.questions";
export type GetKnowledgeQuestionsOperation =
  typeof getKnowledgeQuestionsOperation;

export function getKnowledgeQuestions(
  cursor: string | null,
): ResultAsync<
  KnowledgeQuestionsResponse,
  BackendFailure<GetKnowledgeQuestionsOperation>
> {
  const query = cursor === null ? "" : `?${new URLSearchParams({ cursor })}`;
  return requestBackendResult({
    method: "GET",
    operation: getKnowledgeQuestionsOperation,
    parse: (payload) => knowledgeQuestionsResponseSchema.parse(payload),
    path: `${paths.knowledgeQuestions}${query}`,
  });
}
